// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDashOutlinedSvg from "@fishx/icons-svg/es/asn/PDashOutlined";
import FishxIcon from '../components/FishxIcon';

var PDashOutlined = function PDashOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDashOutlinedSvg
  }));
};

PDashOutlined.displayName = 'PDashOutlined';
export default React.forwardRef(PDashOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDashOutlined.js
// module id = 3315
// module chunks = 0